import React from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../../utils/responsive";

export default function Banner4() {
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            padding: isMobile ? "20px 40px" : "40px 150px",
            alignItems: "center",
          }}
        >
          <p className="m-0 text-center text-uppercase body-lg">
            REDEFINING LUXURY WITH PURPOSE
          </p>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
